import React, { useState, useEffect } from "react";
import Header from "../commons/Header/Header";
import Sidebar from "../commons/Sidebar/Sidebar";
import { handleApiCall } from "../apis";
import { endpoints } from "../utils/endpoints";
import NewsIcon from "../assets/images/icons/db-icon-1.svg";
import PartnerIcon from "../assets/images/icons/db-icon-2.svg";
import CompetitionIcon from "../assets/images/icons/db-icon-3.svg";
import StreamIcon from "../assets/images/icons/db-icon-4.svg";

const defaultStats = {
  totalNews: 0,
  totalSaudiaCompition: 0,
  totalPartnerStram: 0,
  totalPartnerUpdate: 0,
};

function Dashboard() {
  const [dashboardStats, setDashboardStats] = useState(defaultStats);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchDashboardDetails = async () => {
      try {
        setIsLoading(true);
        const response = await handleApiCall("get", endpoints.getDashboardDetails);
        if (response?.data?.code === 200) {
          const apiData = response?.data?.data || {};
          setDashboardStats({
            totalNews: apiData?.totalNews ?? 0,
            totalSaudiaCompition: apiData?.totalSaudiaCompition ?? 0,
            totalPartnerStram: apiData?.totalPartnerStram ?? 0,
            totalPartnerUpdate: apiData?.totalPartnerUpdate ?? 0,
          });
        }
      } catch (error) {
        // errors handled by handleApiCall
      } finally {
        setIsLoading(false);
      }
    };

    fetchDashboardDetails();
  }, []);

  const getDisplayValue = (value) => {
    if (isLoading) {
      return "...";
    }
    const parsed = Number(value ?? 0);
    if (Number.isNaN(parsed)) {
      return "0";
    }
    return parsed.toLocaleString();
  };
  
  return (
    <div className="container-scroller">
      <Header />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="heading mb-4 d-flex align-items-center">
              <h3 className="text-default weight-400 my-0">Dashboard</h3>
            {/* <div className="d-flex justify-content-end ml-auto" style={{'width': '150px'}}>
                <select className="form-control">
                    <option>All Time</option>
                    <option>Yesterday</option>
                    <option>This Week</option>
                    <option>This Month</option>
                    <option>This Year</option>
                </select>
            </div> */}
            </div>
            <div className="row mx-n2">
                <div className="mb-4 mt-2 col-md-3 px-2">
                    <div className="card d-flex p-4 shadow-sm border flex-row align-items-center" style={{"border-radius":"10px"}}>
                        <div className="flex-fill">
                            <h5>News</h5>
                            <h2 className="mb-0 text-white">{getDisplayValue(dashboardStats.totalNews)}</h2>
                        </div>
                        <div><img src={NewsIcon} alt="News icon"/></div>
                    </div>
                </div>
                <div className="mb-4 mt-2 col-md-3 px-2">
                    <div className="card d-flex p-4 shadow-sm border flex-row align-items-center" style={{"border-radius":"10px"}}>
                        <div className="flex-fill">
                            <h5>Partner Updates</h5>
                            <h2 className="mb-0 text-white">{getDisplayValue(dashboardStats.totalPartnerUpdate)}</h2>
                        </div>
                        <div><img src={PartnerIcon} alt="Partner update icon"/></div>
                    </div>
                </div>
                <div className="mb-4 mt-2 col-md-3 px-2">
                    <div className="card d-flex p-4 shadow-sm border flex-row align-items-center" style={{"border-radius":"10px"}}>
                        <div className="flex-fill">
                            <h5>Saudia Competitions</h5>
                            <h2 className="mb-0 text-white">{getDisplayValue(dashboardStats.totalSaudiaCompition)}</h2>
                        </div>
                        <div><img src={CompetitionIcon} alt="Saudia competition icon"/></div>
                    </div>
                </div>
                <div className="mb-4 mt-2 col-md-3 px-2">
                    <div className="card d-flex p-4 shadow-sm border flex-row align-items-center" style={{"border-radius":"10px"}}>
                        <div className="flex-fill">
                            <h5>Partner Streams</h5>
                            <h2 className="mb-0 text-white">{getDisplayValue(dashboardStats.totalPartnerStram)}</h2>
                        </div>
                        <div><img src={StreamIcon} alt="Partner stream icon"/></div>
                    </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
